export default "__VITE_ASSET__beb23551__"